import React, { useState } from 'react';
import {
    BringzzPageContainer,
    BringzzIcon,
    BringzzText,
    BringzzImage,
} from '@bringzz/components';
import { useNavigation } from 'context/NavigationContext';

const StripeOnbordingSuccess = () => {
    const { navigate } = useNavigation();

    return (
        <BringzzPageContainer
            header={{
                left: (
                    <BringzzIcon
                        size='22'
                        icon='IconClose'
                        folder='LineIcons'
                        className='cursor-pointer'
                        onClick={() => navigate('/')}
                    />
                ),
            }}
        >
            <div className='p-4 flex flex-col space-y-4 h-full justify-center items-center'>
                <div className='flex-2 w-2/3 h-full' >
                    <BringzzImage className='w-full' src='/images/SuccessThumbsUp.png' alt='Success' />

                </div>
                <div className='flex-1 w-full h-full  justify-center items-center' >
                    <BringzzText tag='h1' className='text-center'>
                        Your onbording was successful!
                    </BringzzText>

                </div>
                <div className='flex-1 w-full h-full  justify-center items-center' >
                    <BringzzText tag='h4' className='text-center font-thin'>
                        You can now fully enjoy the app.
                    </BringzzText>

                </div>
            </div>
        </BringzzPageContainer>
    );
};

export default StripeOnbordingSuccess;